import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild
} from '@headlessui/react';
import { ReactNode } from 'react';
import { IoClose } from 'react-icons/io5';

const CommonDialog = ({
  isOpen,
  close,
  dialogTitle,
  children,
  childClasses,
  width,
  hideClose
}: {
  isOpen: boolean;
  close?: () => void;
  dialogTitle?: string | ReactNode;
  children?: ReactNode;
  childClasses?: string;
  width?: string;
  hideClose?: boolean;
}) => {
  const handleClose = close ?? (() => undefined);
  return (
    <div>
      <Transition appear show={isOpen}>
        <Dialog
          as='div'
          className='relative z-[1000] focus:outline-none'
          onClose={handleClose}
        >
          {/* <div
            className='fixed left-0 top-0 z-50 h-screen w-full bg-black bg-opacity-50'
            aria-hidden='true'
          ></div> */}

          <div className='fixed inset-0 z-[1000] w-screen overflow-y-auto bg-[rgba(0,0,0,0.5)]'>
            <div className='flex min-h-full items-center justify-center'>
              <TransitionChild
                enter='ease-out duration-300'
                enterFrom='opacity-0 transform-[scale(95%)]'
                enterTo='opacity-100 transform-[scale(100%)]'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 transform-[scale(100%)]'
                leaveTo='opacity-0 transform-[scale(95%)]'
              >
                <DialogPanel
                  className={` ${width ?? 'w-full max-w-fit '} rounded-xl border border-[#E3E5E9] bg-white shadow-md backdrop-blur-2xl`}
                >
                  <DialogTitle
                    as='h3'
                    className='flex items-center justify-between border-b border-[#E3E5E9] py-2 pl-6 pr-2 text-base/7 font-medium text-black'
                  >
                    {dialogTitle}
                    {!hideClose && (
                      <button onClick={handleClose}>
                        <IoClose />
                      </button>
                    )}
                  </DialogTitle>

                  <div className={`${childClasses ?? 'px-6 pb-4 pt-2'} `}>
                    {children}
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default CommonDialog;
